import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class RandomNumberGeneratorService {
  randomNumber(): number {
    const crypto = window.crypto;
    const array = new Uint32Array(1);
    crypto.getRandomValues(array);
    const number = array[0];
    return number;
  }
}
